import { render, staticRenderFns } from "./customer-contract-edit.vue?vue&type=template&id=8b56be4e&scoped=true"
import script from "./customer-contract-edit.vue?vue&type=script&lang=js"
export * from "./customer-contract-edit.vue?vue&type=script&lang=js"
import style0 from "./customer-contract-edit.vue?vue&type=style&index=0&id=8b56be4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b56be4e",
  null
  
)

export default component.exports